import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { BaseCtaWithLink } from './BaseCtaWithLink';
export var ReactivateCta = function ReactivateCta(_ref) {
  var schedule = _ref.schedule,
      props = _objectWithoutProperties(_ref, ["schedule"]);

  return React.createElement(BaseCtaWithLink, _extends({}, props, {
    className: "bt--primary bt--outline",
    to: "/rejoin",
    onClick: function onClick() {
      ga('Venue Details', 'Schedule Join Click', schedule.id);
    }
  }), React.createElement(FormattedMessage, {
    id: "schedule.row.cta-join",
    defaultMessage: "Join"
  }));
};
ReactivateCta.propTypes = {
  schedule: PropTypes.shape({
    id: PropTypes.number.isRequired
  })
};